export const subTitle = `
  Status synchronization for MANAGED_KYC & MANAGED_SME_KYC might take a while.
  If the widgets do not load properly, wait around a minute and reload it from the original link.
`;
export const title = 'Create a widget URL';
